import { getContext } from '@fiverr-private/fiverr_context';
import { currencyFormat, getLocalizationContext } from '@fiverr-private/localization';
import type { Currency } from '@fiverr-private/currencies_plugin';

const DEFAULT_CURRENCY = 'USD';

export const centsToCurrency = (usdCents: number, currency?: Currency) => {
    const { currency: _contextCurrency = 'USD' } = getContext();
    const localizationContext = getLocalizationContext();
    const contextCurrency = _contextCurrency ? _contextCurrency : DEFAULT_CURRENCY;
    const amountInDollars = usdCents / 100;
    const fallbackValue = `$${amountInDollars.toFixed(2)}`;

    if (!currency || !currency.rate) {
        return fallbackValue;
    }

    const currencyCode = currency?.name || contextCurrency;
    const value = currency?.rate ? amountInDollars * currency?.rate : amountInDollars;

    return currencyFormat({
        localizationContext,
        value,
        currencyCode,
        options: {
            fallbackValue,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        },
    });
};
